import { discourseSections } from './reading-unit.js';

const normalize = value => String(value || '').replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
const aliases = row => [row?.ref, row?.readerRef, row?.targetRef].filter(Boolean);
const discourseKey = ref => normalize(ref).match(/^(.*?\b(?:sicha|maamar)\s+\d+)(?=,|\s+(?:section|seif)|$)/)?.[1]
  || normalize(ref).match(/^(.*?:(?:sicha|maamar):[^:]+)(?=:|$)/)?.[1] || '';

export function printScopeSegments(sicha, currentRef, tocSections) {
  const rows = (tocSections || []).filter(row => !row.isHeader);
  const current = currentRef || sicha._liveTargetRef || sicha._liveRef || sicha.id;
  const row = rows.find(item => aliases(item).some(ref => normalize(ref) === normalize(current)));
  const discourse = row ? discourseSections({ sections: rows }, { ref: row.ref, readerRef: row.readerRef, tocTargetRef: row.targetRef }) : [];
  const wanted = new Set((discourse.length ? discourse.flatMap(aliases) : row ? aliases(row) : [current]).map(normalize));
  const fallbackDiscourse = !row ? discourseKey(current) : '';
  return (sicha.segments || []).filter(segment => {
    const ref = segment._sectionRef || segment._sectionCanonicalRef || sicha._liveTargetRef || sicha._liveRef || sicha.id;
    return wanted.has(normalize(ref)) || fallbackDiscourse && discourseKey(ref) === fallbackDiscourse;
  });
}
